import { defineMessages } from 'react-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	title2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickStartTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	quickStartAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tabSearch: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tabRovo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'home.title.non-final',
		defaultMessage: 'Power your data discovery',
		description: 'Title for the home page',
	},
	description: {
		id: 'home.description.non-final',
		defaultMessage: 'Search across entities, relationships, creators and data types',
		description: 'Description for the home page',
	},
	title2: {
		id: 'home.title2.non-final',
		defaultMessage: 'Explore our tools',
		description: 'Title for the home page',
	},
	description2: {
		id: 'home.description2.non-final',
		defaultMessage: 'Try out one of our tools and explore the graph',
		description: 'Description for the home page',
	},
	quickStartTitle: {
		id: 'home.quickStartTitle.non-final',
		defaultMessage: 'Quick Start',
		description: 'Title for the quick start section',
	},
	quickStartAction: {
		id: 'home.quickStartAction.non-final',
		defaultMessage: 'View all',
		description: 'Action for the quick start section',
	},
	tabSearch: {
		id: 'home.tabSearch.non-final',
		defaultMessage: 'Search',
		description: 'Label for the search tab',
	},
	tabRovo: {
		id: 'home.tabRovo.non-final',
		defaultMessage: 'Ask Rovo',
		description: 'Label for the Ask Rovo tab',
	},
	searchPlaceholder: {
		id: 'home.searchPlaceholder.non-final',
		defaultMessage: 'How do I connect my Jira issues to code?',
		description: 'Placeholder for the search input',
	},
});
